import React, { useEffect, useMemo, useRef, useState } from "react";
import DetailWrapper from "../../../components/detailWrapper";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import { HiChevronLeft } from "react-icons/hi";
import { useLocation, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { languageTransfer } from "../../../utils/languageTransfer";
import i18next from "i18next";
import { COMMON_WEB_PATH, LOTTERY_LINK } from "../../../constant";
import { REPLACE_AIR } from "../../../replace_str_constant";
import { AiOutlineClose, AiOutlineHeart } from "react-icons/ai";
import { Button, Divider } from "semantic-ui-react";
import GameCatalog from "../../../components/GameCatalog";
import TabTransfer from "../../PointQuery/tabTransfer";
import { Link } from "react-router-dom";
import { storeGameConfig } from "../../../redux/action/game/gameAction";
import { isEmptyObject } from "../../../utils/isEmptyObject";
import LazyImage from "../../../components/Loading/lazyImage";
import LoadingLine from "../../../components/Loading/LoadingLine";
import { AnimatePresence, motion, useWillChange } from "framer-motion";
import AnimateWrapper from "../../../components/Animate/animateWrapper";
import useGetNowGame from "../../../hook/useGetNowGame";
import ToggleFavorite from "../../../components/Favorite/toggleFavorite";
import { useTranslation } from "react-i18next";
import { getRandomSlice, shuffle } from "../../../utils/shuffle";
import {
  openGameDescriptionPop,
  storeTransferWallet,
} from "../../../redux/action/member/memberAction";
import useDescriptionConfig from "../gameDescription/descriptionConfig";
import useGameIsHasDescription from "../gameDescription/gameIsHasDescription";
import useDetectedPlayerWalletBalance from "../../../hook/useDetectedPlayerWalletBalance";
import NoticeTransfer from "./noticeTransfer";
import useTransferMode from "../../../hook/useTransferMode";
import { isLoggedIn } from "../../../utils/isLoggedIn";
import UserClickGameCatalog from "../../../components/UserClickGameCatalog";
import { closeAccessTool } from "../../../redux/action/game/gameAction";
import VipBar from "./vipBar";
import RewardList from "./rewardList";
import { getTransferWallet } from "../../../api/getApi";
import { flattenWalletObject } from "../../../utils/flattenObject";

const GameConfirm = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`gamebox.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  const navigate = useNavigate();
  const location = useLocation();

  const { to, gameUid } = useParams();

  const [showRewards, setShowRewards] = useState(false);
  const iconStyle =
    "min-w-[44px] min-h-[44px] rounded-full active:scale-[0.95] dark:bg-base-light-dark text-base-dark dark:text-base-white text-2xl flex items-center justify-center";

  const gameConfig = useSelector((state) => state.isGameConfig);
  const handleAllGame = useSelector((state) => state.isHandleAllGame);
  const isTriggerTransferTab = useSelector(
    (state) => state.isTriggerTransferTab
  );
  const dispatch = useDispatch();
  const { topGameList, sortedByPlatformGames, allGames, allGamePlatform } =
    handleAllGame;

  const nowGameConfig = useGetNowGame();
  const willChange = useWillChange();

  useEffect(() => {
    dispatch(storeGameConfig(nowGameConfig));
  }, [nowGameConfig]);

  const { game_platform, gameCode, game_subtype } = gameConfig;

  const [showBlock, setShowBlock] = useState(false);
  const [openTransfer, setOpenTransfer] = useState(false);
  const [animate, setAnimate] = useState(true);
  const [flicker, setFlicker] = useState(false);
  const [triggerTransferPop, setTriggerTransferPop] = useState(false);

  const scrollContainerRef = useRef(null);

  const previousIsGameConfirm = useMemo(() => {
    if (location.pathname.includes("game-confirm")) {
      return true;
    }
  }, []);

  const isTransferMode = useTransferMode();

  useEffect(() => {
    if (isTriggerTransferTab) {
      setOpenTransfer(true);
    }
  }, [isTriggerTransferTab]);

  useEffect(() => {
    if (isTransferMode) {
      getTransferWallet().then((data) => {
        dispatch(
          storeTransferWallet(flattenWalletObject(data.transferGameWalletInfo))
        );
      });
    }
  }, [isTransferMode]);

  const gameIsHasDescription = useGameIsHasDescription({ game_platform });

  const getPrevPath = useMemo(() => {
    const path = location.pathname.split("/");
    const currentPathIndex = path.findIndex((item) => item === "game-confirm");

    if (currentPathIndex === -1) return "";

    return `${path.slice(0, currentPathIndex).join("/")}`;
  }, [location.pathname]);

  useEffect(() => {
    const fixedElement = document.getElementById("fixed-game-confirm");
    const handleScroll = (event) => {
      if (fixedElement.scrollTop > 10) {
        setShowBlock(true);
      } else {
        setShowBlock(false);
      }
    };
    fixedElement?.addEventListener("scroll", handleScroll);

    return () => {
      fixedElement?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [gameConfig]);

  const topGameRandom = useMemo(() => {
    return getRandomSlice(topGameList);
  }, [gameConfig]);

  const detectedPlayerWalletBalanceBiggestThanZero =
    useDetectedPlayerWalletBalance({ to });

  return (
    <AnimateWrapper //渲染名为 AnimateWrapper 的 React 组件，并把一个名为 animate 的属性传给 AnimateWrapper 组件，根据传递的 animate 属性的值，AnimateWrapper 组件将在内部决定是否渲染其子组件以及是否触发动画效果。
      animate={animate}
    >
      <motion.section
        initial={{ scale: 0.5, opacity: 0 }} //组件的初始状态，定义了 scale（缩放比例）和 opacity（不透明度）的初始值。初始时，元素的规模为 0.5，透明度为 0。
        animate={{ scale: 1, opacity: 1 }} //定义了组件在活动状态下的属性值。在活动状态下，元素的规模为 1，透明度为 1，表示元素将被缩放到原始大小并变得完全可见。
        exit={{ scale: 0.5, opacity: 0 }} //定义了组件在退出动画时的属性值。在退出动画时，元素的规模将再次缩小至 0.5，透明度将减小至 0，表示元素将渐变消失。
        transition={{
          duration: 0.3, //动画的持续时间为 0.3 秒，表示从一个状态到另一个状态的过渡将在 0.3 秒内完成。
          ease: [0.43, 0.13, 0.23, 0.96],
        }}
        style={{ willChange }}
        ref={scrollContainerRef}
        id="fixed-game-confirm"
        className={`h-full w-full overflow-y-scroll no-scrollbar fixed top-0 left-0 z-[99999] !px-0 bg-[#eee]`}
      >
        {triggerTransferPop && isTransferMode ? (
          <NoticeTransfer
            triggerTransferPop={triggerTransferPop}
            setTriggerTransferPop={setTriggerTransferPop}
          />
        ) : null}

        <section
          className={`${
            showBlock && "bg-base-white dark:bg-base-dark"
          } transition duration-300 fixed top-0 left-0 px-[10px] w-full h-[60px] flex items-center justify-between z-[1]`}
        >
          <Link
            onClick={() => {
              setAnimate(false);
              setTimeout(() => {
                navigate(previousIsGameConfirm ? getPrevPath : -1);
              }, 300);
            }}
            // to={previousIsGameConfirm ? getPrevPath : -1}
            className="p-[4px] cursor-pointer rounded-full bg-light-white flex items-center justify-center"
          >
            <AiOutlineClose className="text-xl text-light-text" />
          </Link>
          <span className="text-xl font-bold text-base-light-dark dark:text-base-light-white">
            {showBlock &&
              gameConfig?.[
                `gameName${languageTransfer({ lang: i18next.language })}`
              ]}
          </span>
          <span>&nbsp;</span>
        </section>
        <section className="relative">
          <LazyImage
            src={`${COMMON_WEB_PATH}/gameIcon/en/${game_platform}/${REPLACE_AIR(
              gameCode
            )}.webp`}
            alt={
              gameConfig?.[
                `gameName${languageTransfer({ lang: i18next.language })}`
              ]
            }
            className="w-full h-[292px] object-cover"
          />
          <img
            src={`${COMMON_WEB_PATH}/gameIcon/en/${game_platform}/${REPLACE_AIR(
              gameCode
            )}.webp`}
            alt={`${game_platform}_${gameCode}`}
            className="absolute top-[292px] rotate-180 w-full h-[292px] object-cover"
          />
        </section>
        <section className="game-confirm-blur px-[16px] pt-[16px] flex flex-col gap-[5px]">
          <div className="flex items-center justify-between ">
            <LoadingLine className={`!w-[100px] !h-[10px]`}>
              <span className="text-xl font-bold text-base-light-dark dark:text-base-light-white">
                {
                  gameConfig?.[
                    `gameName${languageTransfer({ lang: i18next.language })}`
                  ]
                }
              </span>
            </LoadingLine>
            <div className="flex gap-2 items-center justify-center">
              {isLoggedIn() && (
                <div
                  onClick={() => {
                    setShowRewards((prevTab) => !prevTab);
                  }}
                  className={`${iconStyle} ${
                    showRewards && "border border-main-color"
                  }`}
                >
                  <img
                    alt={`vipIcon`}
                    src="https://leoncasino.gcdn.co/img/beginner.a4dcaa95.png"
                    className="w-[32px] h-[32px]"
                  />
                </div>
              )}
              <ToggleFavorite />
            </div>
          </div>
          <div className="flex items-start justify-between">
            <LoadingLine className={`!w-[50px] !h-[10px]`}>
              <span className="font-medium tracking-tighter text-base-light-dark dark:text-base-light-white">
                {game_platform}‧{game_subtype}
              </span>
            </LoadingLine>

            <div className="flex flex-col gap-[3px] text-sm items-end">
              {gameIsHasDescription && (
                <span
                  onClick={() => {
                    dispatch(openGameDescriptionPop({ game: game_platform }));
                  }}
                  className="text-main-color underline"
                >
                  {`>>`} {i18n_common("ruleIntro")}
                </span>
              )}
              {gameConfig?.game_type === "LOTTERY" && (
                <a
                  href={LOTTERY_LINK}
                  target="_blank"
                  className="text-main-color underline"
                >
                  {`>>`} {i18n_common("vietInstantLottery")}
                </a>
              )}
            </div>
          </div>
          <span className="text-red-500">
            {!detectedPlayerWalletBalanceBiggestThanZero && isTransferMode
              ? `*${i18n("pleaseTransfer")}`
              : null}
          </span>

          <div className="grid grid-cols-3 items-center gap-[10px]">
            <Button
              type="button"
              size="xl"
              onClick={() => {
                dispatch(closeAccessTool());
                // if (
                //   !detectedPlayerWalletBalanceBiggestThanZero &&
                //   isTransferMode
                // ) {
                //   setTriggerTransferPop(true);
                //   return;
                // }
                navigate(
                  `/gamebox/${
                    gameConfig?.[
                      `gameName${languageTransfer({
                        lang: i18next.language,
                      })}`
                    ]
                  }/${to}/${gameUid}`
                );
              }}
              className={`!bg-main-color !text-white !py-[15px] !mt-[10px] ${
                isTransferMode ? "col-span-2" : "col-span-3"
              }`}
            >
              {i18n_common("PLAY")}
            </Button>
            {isTransferMode && (
              <Button
                type="button"
                size="xl"
                onClick={() => {
                  setOpenTransfer(!openTransfer);
                }}
                className="!bg-green-500 !text-white !py-[15px] !mt-[10px] !w-full"
              >
                {i18n_common("TRANSFER")}
              </Button>
            )}
          </div>
          {showRewards && (
            <>
              <Divider />
              <RewardList />
            </>
          )}

          {isTransferMode && openTransfer && (
            <section>
              <Divider />
              <TabTransfer />
            </section>
          )}
        </section>
        <section className="bg-base-white dark:bg-base-dark w-full relative z-[1] pt-[20px] flex flex-col gap-[10px]">
          <GameCatalog
            wrapperClassName={`!my-0`}
            list={topGameRandom}
            mainTitle={`Top`}
            swiperProps={{
              customPerView: "confirm-layout",
            }}
          />
          <GameCatalog
            dontTranslateMainTitle
            wrapperClassName={`!my-0`}
            list={sortedByPlatformGames?.[game_platform]}
            mainTitle={`${game_platform}`}
            swiperProps={{
              customPerView: "confirm-layout",
            }}
            directToPlatform={game_platform}
          />
        </section>
      </motion.section>
    </AnimateWrapper>
  );
};

export default GameConfirm;
